import React, { useEffect, useContext, useState, useRef } from "react";
import { toast } from "react-toastify";
import "../../../Utils/sd-styles/sd-css/main.css";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "react-router";
import { SD_Context } from "../../../context/sd-context";
import {
  sd_btn_loading,
  sd_dashboard_edit_ico,
  sd_dashboard_side_arrow,
  sd_failure_icon,
  sd_success_icon,
} from "../../../Assets/imageList";
import ParokshaSevaService from "../../../services/sd-parokshaseva.service";
import DisplayRazorpay from "../../../Utils/sd-razorpay/sd-razorpay-display";
import moment from "moment";
import Sd_loading from "../../../Components/sd-common-components/sd-loading";
import { BASE_BANK } from "../../../Utils/sd-axios/sd-api-url";

const Sd_dashboard_quick_booking_donations_confirm = ({ history }) => {
  //-------------------------------------------------------------states--------------------------------------------------------//
  const [successOrfailureFlag, setSuccessOrfailureFlag] = useState(false);
  const templeID = process.env.REACT_APP_TEMPLE ?? "SSVVSD";
  const [status, setStatus] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedlanguage, setSelectedlanguage] = useState("en-in");
  const [loading, setLoading] = useState(true);
  const [dissmissed, setDissmissed] = useState("");
  const [halfState, setHalfState] = useState(null);
  const refContainer = useRef();
  const supportedLanguages = ["en-in", "jp-in", "de-in", "es-in"];
  const [timestamp, setTimestamp] = useState("");

  const {
    setActive,
    setActivePath,
    currentQuickBookingDonation,
    userData,
    logout,
    setCurrentQuickBookingDonation,
  } = useContext(SD_Context);
  //-------------------------------------------------------------states--------------------------------------------------------//
  //-------------------------------------------------------------useeefect--------------------------------------------------------//
  useEffect(async () => {
    setLoading(true);
    if (
      supportedLanguages.includes(
        history?.location?.pathname?.split?.("/")?.[1]
      )
    ) {
      setSelectedlanguage(history?.location?.pathname?.split?.("/")?.[1]);
    } else {
      setSelectedlanguage("en-in");
    }
    if (!currentQuickBookingDonation) {
      history?.push(`/${selectedlanguage}/devotee-app/quick-booking/donations`);
    }

    setActive("quick-booking-donations-confirm-details");
    setActivePath("Quick-Booking-Donations-Confirm Details");
    setTimestamp("");
    setLoading(false);
    return () => {
      setTimestamp("");
    };
  }, []);

  useEffect(() => {
    if (dissmissed === "failed") {
      setErrorMsg("Cancelled by User");
      setSuccessOrfailureFlag(true);
      setStatus("failed");
      setLoading(false);
      setDissmissed("");
    }
  }, [dissmissed]);

  useEffect(() => {
    refContainer?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [status]);
  //-------------------------------------------------------------useeeffect--------------------------------------------------------//
  function capitalize(str) {
    let splitStr = str?.toLowerCase?.().split?.(" ");
    for (let i = 0; i < splitStr?.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr?.join(" ");
  }
  //-------------------------------------------------------------functions--------------------------------------------------------//
  const handleSubmit = async () => {
    let res;
    if (!halfState) {
      try {
        setLoading(true);
        // For quick booking, use the first person's name as donor name
        const donorName =
          currentQuickBookingDonation?.personStates?.[0]?.name || "";

        let dto = {
          donationId: Number(currentQuickBookingDonation?.donation?.id),
          devoteeName: donorName,
          amount: Number(currentQuickBookingDonation?.amount),
          address: capitalize(currentQuickBookingDonation?.address1),
          city: capitalize(currentQuickBookingDonation?.city),
          state: currentQuickBookingDonation?.state,
          country: currentQuickBookingDonation?.country,
          pinCode: Number(currentQuickBookingDonation?.zip),
          contact: `+${currentQuickBookingDonation?.mobile}`,
        };

        if (currentQuickBookingDonation?.gothram) {
          dto.gothram = capitalize(currentQuickBookingDonation?.gothram);
        }
        if (currentQuickBookingDonation?.address2 !== "") {
          dto.address2 = capitalize(currentQuickBookingDonation?.address2);
        }
        if (currentQuickBookingDonation?.occasion) {
          dto.occasion = capitalize(currentQuickBookingDonation?.occasion);
        }

        let subDataObj = {
          cartContains: ["donation"],
          donationBookings: [dto],
          returnPriceStats: false,
        };
        res = await ParokshaSevaService.bookings(subDataObj, templeID);
        setHalfState(res);
      } catch (e) {
        toast.error(e.message);
        if (e.message === "Session Expired") {
          logout();

          history?.push(
            `/${selectedlanguage}/devotee/signin?to=devotee-app/quick-booking/donations`
          );
        }
        setLoading(false);

        return;
      }
    }
    if (currentQuickBookingDonation?.res?.totalAmount === 0) {
      setHalfState(null);
      setSuccessOrfailureFlag(true);
      setStatus("success");
      setTimestamp("");
      setLoading(false);
      return;
    }
    try {
      if (halfState !== null) {
        if (Math.floor((Date.now() - timestamp) / 1000) > 900) {
          toast.error(
            "Redirecting to Previous Page as buffer time of 15 min for retrying the payment has been exceeded."
          );
          setTimestamp("");
          setTimeout(() => {
            history?.push(
              `/${selectedlanguage}/devotee-app/quick-booking/donations`
            );
          }, 3000);
          return;
        }

        await DisplayRazorpay(
          halfState?.paymentInformation?.razorOrder?.id,
          halfState?.paymentInformation?.razorOrder?.currency,
          halfState?.paymentInformation?.razorOrder?.amount,
          halfState?.cartItems?.donation,
          halfState?.paymentInformation?.onlinePaymentEntity?.id,
          BASE_BANK,
          setDissmissed,
          userData,
          dissmissed,
          halfState?.priceStats?.templePaymentConfig?.razorpay?.key,
          templeID
        );

        setHalfState(null);
        setCurrentQuickBookingDonation(null);
        setTimestamp("");
        setSuccessOrfailureFlag(true);
        setStatus("success");
        setLoading(false);
      } else {
        setTimestamp(Date.now());

        await DisplayRazorpay(
          res?.paymentInformation?.razorOrder?.id,
          res?.paymentInformation?.razorOrder?.currency,
          res?.paymentInformation?.razorOrder?.amount,
          res?.cartItems?.donation,
          res?.paymentInformation?.onlinePaymentEntity?.id,
          BASE_BANK,
          setDissmissed,
          userData,
          dissmissed,
          res?.priceStats?.templePaymentConfig?.razorpay?.key,
          templeID
        );
        setHalfState(null);
        setSuccessOrfailureFlag(true);
        setStatus("success");
        setTimestamp("");
        setCurrentQuickBookingDonation(null);
        setLoading(false);
      }
    } catch (e) {
      setErrorMsg(e.message);
      setSuccessOrfailureFlag(true);
      setStatus("failed");
      setLoading(false);
    }
  };

  const getStatusFunction = () => {
    switch (status) {
      case "success":
        return (
          <div className="sd-success" ref={refContainer}>
            <div className="sd-success-top sd-green">
              <img src={sd_success_icon} alt="success" /> <p>Success</p>
            </div>
            <div className="sd-success-bottom">
              <h3>
                Thanks for your e-hundi donation! Your contribution shall be
                utilized for noble causes. May divine blessings always be upon
                you.
              </h3>
              <div className="sd-success-bottom-down">
                <p
                  className="sd-border-right"
                  onClick={() => {
                    history?.push(
                      `/${selectedlanguage}/devotee-app/booking-history`
                    );
                  }}
                >
                  Booking History
                </p>{" "}
                <p
                  onClick={() => {
                    history?.push(`/${selectedlanguage}/home`);
                  }}
                >
                  Go to Home
                </p>
              </div>
            </div>
          </div>
        );
      case "failed":
        return (
          <div className="sd-success" ref={refContainer}>
            <div className="sd-success-top sd-redback">
              <img src={sd_failure_icon} alt="success" />{" "}
              <p>Sorry, your donation could not be placed. {errorMsg} </p>
            </div>
            <div className="sd-success-bottom">
              <h3>
                Your donation was not placed as there was a problem processing
                payment. Check your booking history or SMS after 20 mins for
                confirmation. Please note that any funds debited will credit
                back to your account within 7 working days.
              </h3>
              <div className="sd-success-bottom-down">
                <p
                  className="sd-border-right"
                  onClick={() => {
                    setStatus("");
                    setSuccessOrfailureFlag(false);
                  }}
                >
                  Try Again
                </p>{" "}
                <p
                  onClick={() => {
                    history?.push(`/${selectedlanguage}/support/contactUs`);
                  }}
                >
                  Contact Us
                </p>
              </div>
            </div>
          </div>
        );
    }
  };

  //-------------------------------------------------------------functions--------------------------------------------------------//
  return (
    <div
      className="col-xs-12 col-sm-12 col-md-9 col-lg-9 sd-dashboard"
      style={{
        minHeight: document.getElementById("side-menu")?.offsetHeight,
      }}
    >
      {loading ? (
        <Sd_loading />
      ) : successOrfailureFlag ? (
        getStatusFunction()
      ) : (
        <div className="sd-confirm-details">
          <h2 className="sd-side-heading fw400">
            <span className="fw400">
              <span className="fw700">Confirm</span> Details
            </span>
            <a
              onClick={() => {
                history?.push(
                  `/${selectedlanguage}/devotee-app/quick-booking/donations`
                );
              }}
              className="sd-confirm-edit-button"
            >
              <img src={sd_dashboard_edit_ico} /> Edit details
            </a>
          </h2>
          <div className="clearfix  sd-booking-details">
            <h4>Booking Details</h4>
            <table className="table table-bordered sd-toggle-table">
              <thead>
                <tr>
                  <th width="60%">Booking for</th>
                  <th width="40%">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {currentQuickBookingDonation?.donation?.name}
                    <br></br>(Donations -
                    {currentQuickBookingDonation?.donation?.name})
                  </td>

                  <td>
                    {userData?.phone?.substring(0, 3) === "+91" ? "Rs." : "$"}{" "}
                    {parseFloat(
                      currentQuickBookingDonation?.res?.totalAmount
                    ).toFixed(2)}
                    <br /> (Handling charges:{" "}
                    {userData?.phone?.substring(0, 3) === "+91" ? "Rs." : "$"}{" "}
                    {parseFloat(
                      currentQuickBookingDonation?.res?.templeFee
                    ).toFixed(2)}
                    )
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" height="20px"></td>
                </tr>
              </tbody>
            </table>

            <div className="sd-table-detoggler">
              <div className="sd-booking-details-middle bg">
                <div className="">
                  {" "}
                  <label style={{ color: "grey", fontWeight: 500 }}>
                    BOOKING FOR
                  </label>
                  <span className="fw500">
                    {currentQuickBookingDonation?.donation?.name}
                    <br></br>
                    {currentQuickBookingDonation?.donation?.name} - (Donations)
                  </span>
                </div>
              </div>
              <div className="sd-booking-details-down ">
                <div style={{ marginRight: "0px" }}>
                  {" "}
                  <label>AMOUNT</label>
                  <span>
                    {" "}
                    {userData?.phone?.substring(0, 3) === "+91"
                      ? "Rs."
                      : "$"}{" "}
                    {parseFloat(
                      currentQuickBookingDonation?.res?.serviceAmount
                    ).toFixed(2)}
                    <br />{" "}
                    <span style={{ fontSize: "12px" }}>
                      (Handling charges:{" "}
                      {userData?.phone?.substring(0, 3) === "+91" ? "Rs." : "$"}{" "}
                      {parseFloat(
                        currentQuickBookingDonation?.res?.templeFee
                      ).toFixed(2)}
                    </span>
                  </span>
                </div>
              </div>
              {currentQuickBookingDonation?.occasion && (
                <div className="sd-booking-details-down ">
                  <div>
                    {" "}
                    <label>OCCASION</label>
                    <span> {currentQuickBookingDonation?.occasion}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="clearfix sd-devotee-details mt-30">
            <h4>
              Donor/nominee Details - Mobile: +
              {currentQuickBookingDonation?.mobile}
            </h4>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th width="5%">S.No.</th>
                  <th width="95%">Name</th>
                </tr>
              </thead>
              <tbody>
                {currentQuickBookingDonation?.personStates?.map((obj, i) => {
                  if (obj.name !== "") {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{obj?.name}</td>
                      </tr>
                    );
                  }
                  return null;
                })}
              </tbody>
            </table>
            {(currentQuickBookingDonation?.address1 ||
              currentQuickBookingDonation?.city ||
              currentQuickBookingDonation?.gothram) && (
              <div className="mt-20">
                {currentQuickBookingDonation?.gothram && (
                  <p>
                    <strong>Gothram:</strong>{" "}
                    {currentQuickBookingDonation?.gothram}
                  </p>
                )}
                {(currentQuickBookingDonation?.address1 ||
                  currentQuickBookingDonation?.city) && (
                  <p>
                    <strong>Address:</strong>{" "}
                    {currentQuickBookingDonation?.address1}
                    {currentQuickBookingDonation?.address2 &&
                      `, ${currentQuickBookingDonation?.address2}`}
                    {currentQuickBookingDonation?.city &&
                      `, ${currentQuickBookingDonation?.city}`}
                    {currentQuickBookingDonation?.state &&
                      `, ${currentQuickBookingDonation?.state}`}
                    {currentQuickBookingDonation?.country &&
                      `, ${currentQuickBookingDonation?.country}`}
                    {currentQuickBookingDonation?.zip &&
                      `, ${currentQuickBookingDonation?.zip}`}
                  </p>
                )}
                <p>
                  <strong>Mobile:</strong> +
                  {currentQuickBookingDonation?.mobile}
                </p>
              </div>
            )}
          </div>
          <div className="clearfix mt-50 sd-form">
            <a
              className="sd-btn-orange"
              onClick={() => {
                if (!loading) {
                  handleSubmit();
                }
              }}
            >
              Proceed to Payment{" "}
              {loading ? (
                <img
                  src={sd_btn_loading}
                  alt=".."
                  className="sd-arrow-btn ml-5 h-20"
                />
              ) : (
                <img
                  className="sd-arrow-btn ml-10"
                  src={sd_dashboard_side_arrow}
                />
              )}
            </a>
          </div>
        </div>
      )}{" "}
    </div>
  );
};
export default withRouter(Sd_dashboard_quick_booking_donations_confirm);
